export default __webpack_public_path__ + "static/media/betSlipBg.7aeb7819.png";